/**
 * Helper: resolves an audit entry's entity reference to an in-app route
 * for the cross-link drill-down on the Audit Log table and drawer.
 *
 * Returns null when the entity has no dedicated surface (system / session
 * events, vendors that aren't yet wired into the integration hub).
 */
const FRAMEWORK_NAMES = new Set([
  "EU AI Act", "NIST AI RMF", "ISO 42001", "APRA CPS 234",
  "Privacy Act (AU)", "ASIC RG 271", "AU AI Ethics",
]);

export function resolveAuditTargetRoute(entry) {
  if (!entry) return null;
  const { entityType, entityRef } = entry;
  switch (entityType) {
    case "request":
      return "/deploy/requests";
    case "policy":
      return "/govern/policies";
    case "agent":
      return entityRef?.startsWith("AGT-")
        ? `/govern/agents/${entityRef}`
        : "/govern/agents";
    case "opportunity":
      return "/identify/opportunities";
    case "incident":
      return "/govern/incidents";
    case "framework":
      return FRAMEWORK_NAMES.has(entityRef) ? "/compliance" : null;
    case "report":
      return "/compliance";
    default:
      return null;
  }
}
